import { render } from "./IncomePoint.vue?vue&type=template&id=ced91b70&scoped=true"
import script from "./IncomePoint.vue?vue&type=script&lang=js"
export * from "./IncomePoint.vue?vue&type=script&lang=js"

import "./IncomePoint.vue?vue&type=style&index=0&id=ced91b70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced91b70"]])

export default __exports__